export default{
    medicinalActionDescription: "اقدامات دارویی",
    surgeryActionType: "نوع عمل جراحی",
    surgeryActionDescription: "توضیحات عمل جراحی",
    iCSIType: " نوع iCSI",
    iCSIDescription: " توضیحات iCSI",
    iUIType: "نوع iUI",
    iUIDescription: "توضیحات iUI",
    surgeryAction: "اقدامات جراحی",
    iCSI: "iCSI",
    iUI: "iUI",
}